import { render, staticRenderFns } from "./AddAssociation.vue?vue&type=template&id=627b8e9e&"
import script from "./AddAssociation.vue?vue&type=script&lang=js&"
export * from "./AddAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports